import { Components, Theme } from "@mui/material";

const MuiTypography: Components<Theme>["MuiTypography"] = {
  styleOverrides: {
    root: {
      "-webkit-font-smoothing": "antialiased",
      "-moz-osx-font-smoothing": "grayscale",
    },
  },
};

export default MuiTypography;
